import { useSelector } from 'react-redux';
import gridSelector from 'common/components/grid-view/controllers/selectors';
import * as assetFullSelectors from 'pages/asset-full-view/controllers/selectors';

export const useGetAssetList = () => {
  const selectedItemDetailList = useSelector(
    gridSelector.makeSelectDetailCurrentITemsSelection()
  );

  const assetData = useSelector(assetFullSelectors.assetDataLoading());

  return selectedItemDetailList?.length > 0
    ? selectedItemDetailList
    : assetData
    ? [assetData]
    : [];
};
